import { useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const useUtmify = () => {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;

    // Delay UTMify loading to not block initial render
    const timer = setTimeout(async () => {
      try {
        const res = await axios.get(`${API}/settings/site-info`);
        const utmifyToken = res.data?.utmify_token;
        const backRedirectUrl = res.data?.utmify_back_redirect_url;

        if (!utmifyToken) return;
        if (document.querySelector('script[src*="utmify"]')) return;

        // Load UTMify script async
        const utmScript = document.createElement("script");
        utmScript.src = "https://cdn.utmify.com.br/scripts/utms/latest.js";
        utmScript.setAttribute("data-utmify-prevent-xcod-sck", "");
        utmScript.setAttribute("data-utmify-prevent-subids", "");
        utmScript.async = true;
        utmScript.defer = true;
        document.head.appendChild(utmScript);

        // Load Back Redirect script if configured
        if (backRedirectUrl) {
          // Validate URL to prevent script injection - only allow http(s) URLs
          let safeUrl;
          try {
            const parsed = new URL(backRedirectUrl);
            if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
              throw new Error("Invalid protocol");
            }
            safeUrl = parsed.toString();
          } catch (urlErr) {
            console.warn("[useUtmify] Invalid back_redirect_url, skipping:", urlErr.message);
            return;
          }

          const backScript = document.createElement("script");
          // Use textContent + JSON.stringify to safely embed the URL string
          backScript.textContent = `
            (function() {
              var link = ${JSON.stringify(safeUrl)};
              function setBackRedirect(url) {
                var urlBackRedirect = url.trim() +
                  (url.indexOf('?') > 0 ? '&' : '?') +
                  document.location.search.replace('?', '').toString();
                history.pushState({}, '', location.href);
                history.pushState({}, '', location.href);
                history.pushState({}, '', location.href);
                window.addEventListener('popstate', function() {
                  setTimeout(function() { location.href = urlBackRedirect; }, 1);
                });
              }
              setBackRedirect(link);
            })();
          `;
          document.body.appendChild(backScript);
        }
      } catch (err) {
        console.warn("[useUtmify] Failed to load tracking scripts:", err?.message || err);
      }
    }, 2000); // 2 second delay - load content first, then tracking

    return () => clearTimeout(timer);
  }, []);
};

export default useUtmify;
